import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getCreativeBySlug } from '../data/creativesRegistry';

const CreativeViewPage = () => {
    const { slug } = useParams();
    const creative = getCreativeBySlug(slug);

    // If creative not found, redirect to creatives list
    if (!creative) {
        return <Navigate to="/creatives" replace />;
    }

    const CreativeComponent = creative.component;

    return (
        <div className="w-full h-screen overflow-hidden">
            <CreativeComponent />
        </div>
    );
};

export default CreativeViewPage;
